class QuickAccessPopup extends HTMLElement {
  constructor() {
    super();
    this._onCloseClick = this._onCloseClick.bind(this);
    this._onBackdropClick = this._onBackdropClick.bind(this);
    this._onButtonClick = this._onButtonClick.bind(this);
    this._onAllClick = this._onAllClick.bind(this);
  }

  connectedCallback() {
    this.backdrop = this.querySelector('[data-qa-element=\"backdrop\"]');
    this.dialog = this.querySelector('[data-qa-element=\"dialog\"]');
    this.closeButtons = this.querySelectorAll('[data-qa-action=\"close\"]');
    this.allButton = this.querySelector('[data-qa-action=\"all\"]');
    this.itemButtons = this.querySelectorAll('[data-qa-action=\"item\"]');

    const storageKey = this.dataset.storageKey || 'quick-access-popup-shown';
    this.storageKey = storageKey;

    const isHomepage = window.location.pathname === '/';
    if (!isHomepage) {
      this.classList.add('is-hidden');
      return;
    }

    const hasCartAddParams = new URLSearchParams(window.location.search).has('add');
    if (hasCartAddParams) {
      this.classList.add('is-hidden');
      return;
    }

    const openOncePerSession = this.dataset.openOncePerSession === 'true';
    const hasSeen = openOncePerSession && window.sessionStorage.getItem(storageKey) === 'true';

    if (hasSeen || this.itemButtons.length === 0) {
      this.classList.add('is-hidden');
      return;
    }

    this._bindEvents();
    this._open();
  }

  disconnectedCallback() {
    this._unbindEvents();
  }

  _bindEvents() {
    if (this.backdrop) {
      this.backdrop.addEventListener('click', this._onBackdropClick);
    }

    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', this._onCloseClick);
    });

    if (this.allButton) {
      this.allButton.addEventListener('click', this._onAllClick);
    }

    this.itemButtons.forEach((btn) => {
      btn.addEventListener('click', this._onButtonClick);
    });
  }

  _unbindEvents() {
    if (this.backdrop) {
      this.backdrop.removeEventListener('click', this._onBackdropClick);
    }

    this.closeButtons.forEach((btn) => {
      btn.removeEventListener('click', this._onCloseClick);
    });

    if (this.allButton) {
      this.allButton.removeEventListener('click', this._onAllClick);
    }

    this.itemButtons.forEach((btn) => {
      btn.removeEventListener('click', this._onButtonClick);
    });
  }

  _open() {
    this.classList.add('is-open');
  }

  _close() {
    this.classList.remove('is-open');
    this.classList.add('is-hidden');

    try {
      window.sessionStorage.setItem(this.storageKey, 'true');
    } catch (e) {
      // ignore
    }
  }

  _onBackdropClick() {
    this._close();
  }

  _onCloseClick(event) {
    event.preventDefault();
    this._close();
  }

  _onAllClick(event) {
    event.preventDefault();
    this._close();
  }

  _onButtonClick(event) {
    const btn = event.currentTarget;
    const url = btn.dataset.url;

    this._close();

    if (url) {
      window.location.href = url;
    }
  }
}

if (!customElements.get('quick-access-popup')) {
  customElements.define('quick-access-popup', QuickAccessPopup);
}

